import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/brand-close.png'
import _imports_1 from '../assets/images/collect-no.svg'


const _withScopeId = n => (_pushScopeId("data-v-1fd4d23c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "digital_corpus_setting" }
const _hoisted_2 = { class: "top_view" }
const _hoisted_3 = {
  key: 0,
  class: "yl-add-btn"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击上传", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "yl-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "yl-right"
}
const _hoisted_8 = { class: "item_count" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "knowledge_list_empty"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无内容", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "used_word_count_bg" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已使用", -1))
const _hoisted_17 = { class: "used_word_count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_SubViewLoadingView = _resolveComponent("SubViewLoadingView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackButtonItem, {
        onBackBtnClick: _ctx.backButtonClick,
        class: "back_button"
      }, null, 8, ["onBackBtnClick"]),
      _createVNode(_component_el_upload, {
        class: "upload_file",
        accept: ".txt, .xls, .xlsx, .pdf, .doc, .docx",
        drag: "",
        "on-error": _ctx.handleError,
        "on-success": _ctx.handleSuccess,
        "http-request": (item) => _ctx.uploadFile(item.file),
        "before-upload": _ctx.beforeUPload,
        "show-file-list": false
      }, {
        default: _withCtx(() => [
          ((_ctx.knowledgeList.length < 5 && _ctx.knowledgeUsed <= _ctx.knowledgeTotal) || (_ctx.linkardType == 1 && _ctx.knowledgeUsed <= _ctx.knowledgeTotal))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["on-error", "on-success", "http-request", "before-upload"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.knowledgeList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowledgeList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "yl-list-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.linkardType != 1 ? index + 1 + '/5' : ''), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(['knowledge_item_bg', item.status == 2 ? 'knowledge_item_bg_success' : '', item.status == 1 ? 'knowledge_item_bg_process' : ''])
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.filename), 1),
                  _createElementVNode("img", {
                    class: "status_icon",
                    src: item.statusImage,
                    alt: ""
                  }, null, 8, _hoisted_9)
                ], 2),
                _createElementVNode("span", {
                  class: "status_label_black",
                  style: _normalizeStyle({ color: item.statusColor })
                }, _toDisplayString(item.statusTips), 5),
                _createElementVNode("img", {
                  class: "delete_icon",
                  src: _imports_0,
                  alt: "",
                  onClick: ($event: any) => (_ctx.deleteYl(item, index))
                }, null, 8, _hoisted_10)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.knowledgeUsed) + "/" + _toDisplayString(_ctx.knowledgeTotal) + "字", 1)
    ]),
    _createVNode(_component_SubViewLoadingView, { msg: _ctx.subLoadingInfo }, null, 8, ["msg"])
  ]))
}